import axios from "axios";
import {
    authorizationServicesPath, ordersServicesPath,
} from "../../../Constants";

const workerRestUrl = authorizationServicesPath + '/organizations/organization-user-entity'
const workersOrdersServicesUrl = ordersServicesPath + '/organizations/workers'

export default class WorkerService {

    static async getAll() {
        return axios.get(workerRestUrl);
    }

    static async getAllOwn() {
        return axios.get(workerRestUrl + "/own");
    }

    static async editOwn(data) {
        return axios.patch(workerRestUrl + "/own", JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getWorkers() {
        return axios.get(workerRestUrl + "/enabled-production");
    }

    static async getOrganizationWorkers() {
        return axios.get(workersOrdersServicesUrl + '/for-jobs');
    }

    static async getAllEnabledAndConstructor() {
        return axios.get(workerRestUrl + "/enabled-and-constructor");
    }

    static async getAllByJobId(id) {
        return axios.get(workersOrdersServicesUrl + '/jobs/' + +id);
    }

    static async update(id, data) {
        return await axios.put(workerRestUrl + '/super/' + id, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(workerRestUrl + '/super/' + id);
    }

    static async unable(id, status) {
        return axios.patch(workerRestUrl + '/super/' + id + '/unable?status=' + status, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async unableProduction(id, status) {
        return axios.patch(workerRestUrl + '/super/' + id + '/unable-production?status=' + status, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async unableConstructor(id, status) {
        return axios.patch(workerRestUrl + '/super/' + id + '/unable-constructor?status=' + status, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async save(email) {
        return await axios.post(workerRestUrl + "?email=" + email, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}